import React from 'react'
import PropTypes from "prop-types"

export default class LastColumn extends React.Component<any> {

    static propTypes = {
        module: PropTypes.object,
    }

    render() {
        const styles = {
            width: this.props.module.skin.paddingRight
        }

        return (
            <div className="last-column" style={styles}>
                {this.props.children}
            </div>
        )
    }
}
